// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_7MC","cls2":"CiterightInfoBanner-cls2_8BR CiterightInfoBanner-cls1_7MC"};